import { createFileRoute } from '@tanstack/react-router';
import { PayoutTemplatesList } from '@/components/tenants/PayoutTemplatesList';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/payout-templates/')({
  component: PayoutTemplatesIndexRoute,
});

function PayoutTemplatesIndexRoute() {
  const { tenantCode } = Route.useParams();

  return <PayoutTemplatesList tenantCode={tenantCode} />;
}
